export const DateBoxViews = {
    rounded: 'rounded',
    square: 'square',
}